import DividerViewV3 from './DividerViewV3';

export default DividerViewV3;
